import {
    AsyncResult,
    callActionOrExecute,
    DataServiceQuery,
    IContext,
    IDataServiceRequest,
    IQueryResultSettings
} from '@msdyn365-commerce/retail-proxy';
import { BrandSchemeEntityExtensionClass, IBrandSchemeEntity } from './entities/brand-scheme-entity';

/** Whitelist for brand schemes that should be prominently displayed. */
export const BrandSchemesWhitelist = [
    'asc',
    'blomsten',
    'brodskalaen_ekstragrovt',
    'brodskalaen_fint',
    'brodskalaen_grovt',
    'brodskalaen_halvgrovt',
    'dyrevernmerket',
    'eus_okologimerke',
    'fairtrade',
    'msc',
    'nokkelhullet',
    'omerket',
    'rainforest_alliance_certified',
    'vegan_society',
    'beskyttedebetegnelser',
    'ce_merket',
    'crossed_grain',
    'demeter',
    'glass_og_gaffelsymbolet',
    'godt_lokalt',
    'grontpunkt',
    'haandverksbakeri',
    'kvalitetsmerket_skrei',
    'naaf',
    'nyt_norge',
    'spesialitet',
    'statskontrollert_okologisk',
    'svanen',
    'v_label'
];
export type BrandSchemeId = typeof BrandSchemesWhitelist[number];

// @ts-ignore
function brandSchemeQuery(brandSchemeId?: string): DataServiceQuery {
    const key = brandSchemeId ? { BrandSchemeId: brandSchemeId } : null;
    return new DataServiceQuery('BrandScheme', 'BrandSchemeEntity', BrandSchemeEntityExtensionClass, key);
}

export function createGetBrandSchemesByIdsInput(queryResultSettings: IQueryResultSettings, brandSchemeIds: string[]): IDataServiceRequest {
    const query = brandSchemeQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetBrandSchemesByIds',
        true,
        BrandSchemeEntityExtensionClass,
        'true',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IBrandSchemeEntity' },
        { brandSchemeIds: brandSchemeIds }
    );
}

export function getBrandSchemesByIdsAsync(context: IContext, brandSchemeIds: string[]): AsyncResult<IBrandSchemeEntity[]> {
    const request = createGetBrandSchemesByIdsInput(context.queryResultSettings || {}, brandSchemeIds);
    return callActionOrExecute<IBrandSchemeEntity[]>(request, context.callerContext);
}
